import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  instructionsContainer: {
    "& > p": {
      paddingBottom: theme.spacing(2.5)
    }
  }
}));

const CourseQuizInstructions = props => {
  const { instructions } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h4" color="textSecondary">
        {t("courseQuiz.instructions")}
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        color="textSecondary"
        mt={3}
        className={classes.instructionsContainer}
      >
        {instructions && instructions.length > 0 && (
          <>
            <div dangerouslySetInnerHTML={{ __html: instructions }} />
          </>
        )}
      </Box>
    </>
  );
};

export default CourseQuizInstructions;

CourseQuizInstructions.propTypes = {
  instructions: PropTypes.string
};
